import { signOut } from "aws-amplify/auth";

type RedirectRouter = {
  replace: (href: string) => void;
};

export const isAuthPagePathname = (
  pathname: string | null | undefined,
): boolean => pathname?.startsWith("/auth") ?? false;

export const isAuthProtectedPathname = (
  pathname: string | null | undefined,
): boolean => typeof pathname === "string" && !isAuthPagePathname(pathname);

export const signOutAndRedirectToSignIn = async (
  router: RedirectRouter,
): Promise<void> => {
  try {
    await signOut();
  } catch {
    // The sign-in form clears stale sessions again before signIn().
  } finally {
    router.replace("/auth/sign-in");
  }
};
